import { handleActions } from 'redux-actions';

import log from 'utils/logger' // eslint-disable-line

const initialValue = {
  public_keys: [],
  public_keys_by_id: {},
  loading: true,
  showCreator: false
}

export default handleActions({
  SHOW_PUBLIC_KEY_CREATE_MODAL(state) {
    return Object.assign({}, state, { showCreator: true })
  },

  HIDE_PUBLIC_KEY_CREATE_MODAL(state) {
    return Object.assign({}, state, { showCreator: false })
  },

  GET_PUBLIC_KEYS_PENDING(state) {
    return Object.assign({}, state, { loading: true })
  },

  GET_PUBLIC_KEYS_FULFILLED(state, { payload }) {
    const public_keys = payload
    const public_keys_by_id = {}
    public_keys.forEach(public_key => {
      public_keys_by_id[public_key.id] = public_key
    })

    return Object.assign({}, state, { public_keys, public_keys_by_id })
  },

  GET_PUBLIC_KEY_PENDING(state, ...args) {
    log('GET_PUBLIC_KEY_PENDING', args)
    return Object.assign({}, state, { loading: true })
  },

  GET_PUBLIC_KEY_FULFILLED(state, { payload }) {
    const public_key = payload

    const next_public_keys = state.public_keys.map(d => {
      if (d.id === public_key.id)
        return public_key
      else
        return d
    })
    const next_public_keys_by_id = Object.assign({}, state.public_keys_by_id, { [public_key.id] : public_key })
    return Object.assign({}, state, {
      public_keys: next_public_keys,
      public_keys_by_id: next_public_keys_by_id,
      loading: false
    })
  },

  CREATE_PUBLIC_KEY_FULFILLED(state, { payload }) {
    const nextPublicKeys = state.public_keys.concat([payload])
    return Object.assign({}, state, { public_keys: nextPublicKeys })
  },

  DELETE_PUBLIC_KEY_FULFILLED(state, { payload }) {
    const nextPublicKeys = state.public_keys.filter(public_key => {
      return public_key.id !== payload.public_key.id
    })
    return Object.assign({}, state, { public_keys: nextPublicKeys })
  },

}, initialValue)

const PublicKeySelectors = {
  getPublicKey(state, id) {
    log('[PublicKeySelectors getPublicKey] from state with ID', state.public_keys, id)
    return state.public_keys.public_keys_by_id[id]
  },
}

export { PublicKeySelectors }
